import { render, staticRenderFns } from "./TextImageSmall.vue?vue&type=template&id=03f2a490"
import script from "./TextImageSmall.vue?vue&type=script&lang=js"
export * from "./TextImageSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports